// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","header__logo":"header_header__logo__NKtF2","header__logo2":"header_header__logo2__jwPoR","header__menu":"header_header__menu__wr8wO"};